
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class StationeryAddressModal extends Vue {
  @Prop({ required: true }) visible: boolean

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
